import { Box, customStyled } from '@mafc/trolly';
import COLORS from 'theme/colors';

export const InfoWrapperStyle = customStyled(Box)`
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    background: ${props => props.backgroundColor || COLORS.POLO_BLUE_25};
`;

export const ChildInfoWraperStyle = customStyled(Box)(({ theme: { radii, fontSizes } }) => ({
  borderRadius: `${radii[2]}px`,
  background: COLORS.POLO_BLUE_50,
  padding: '12px',
  fontSize: fontSizes[1],
  color: COLORS.BLACK,
}));
